var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webtab-widget-content" }, [
    !_vm.webTab
      ? _c(
          "div",
          { staticClass: "loading-state" },
          [
            _c("a-spin", { attrs: { size: "small" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("auto.loading")))]),
          ],
          1
        )
      : !_vm.iframeUrl
      ? _c("div", { staticClass: "error-state" }, [
          _c("span", { staticClass: "material-icons" }, [
            _vm._v("error_outline"),
          ]),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("auto.widgetUrlCouldNotBeCreated"))),
          ]),
        ])
      : _c("iframe", {
          staticClass: "webtab-iframe",
          attrs: {
            src: _vm.iframeUrl,
            frameborder: "0",
            allow:
              "camera; microphone; geolocation; fullscreen; autoplay; clipboard-read; clipboard-write",
            sandbox:
              "allow-same-origin allow-scripts allow-popups allow-forms allow-modals allow-downloads allow-top-navigation",
          },
        }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }